import api from "./api";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_PERMITTEES_POINTS = API_URL_VERSION + 'pontos-permissionarios';

export const PointTypeList = {
  TAXI: { value: "TAXI", labelKey: "taxi" },
  MOTOTAXI: { value: "MOTOTAXI", labelKey: "motorcycle-taxi" },
  ONIBUS: { value: "ONIBUS", labelKey: "bus" },
  TRANSPORTE_ESCOLAR: { value: "TRANSPORTE ESCOLAR", labelKey: "school-transport" },
  TURISMO: { value: "TURISMO", labelKey: "tourism" }
}

export const permitteesPointsService = {
  findMany: async (params = {}) => {
    try {
      const response = await api.get(ENDPOINT_PERMITTEES_POINTS);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "taxi-stand.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_PERMITTEES_POINTS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "taxi-stand.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_PERMITTEES_POINTS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "taxi-stand.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_PERMITTEES_POINTS}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "taxi-stand.messages.errors.update";
    }
  },
};